import React from "react";

const severityStyles = {
    CRITICAL: "border-red-200 bg-red-50 text-red-700",
    WARNING: "border-amber-200 bg-amber-50 text-amber-700",
    INFO: "border-blue-200 bg-blue-50 text-blue-700",
};

function formatTimestamp(timestamp) {
    if (!timestamp) {
        return "–";
    }
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) {
        return "–";
    }
    return date.toLocaleString("de-DE");
}

export default function LogAlertsPanel({ alerts, isLoading }) {
    if (isLoading) {
        return (
            <div className="rounded-xl border border-slate-200 bg-white p-5 text-sm text-slate-500 shadow-sm">
                Alerts werden aktualisiert ...
            </div>
        );
    }

    if (!alerts?.length) {
        return (
            <div className="rounded-xl border border-dashed border-slate-200 p-5 text-sm text-slate-500">
                Keine Auffälligkeiten im ausgewählten Zeitraum.
            </div>
        );
    }

    return (
        <div className="space-y-3">
            {alerts.map((alert, index) => {
                const style = severityStyles[alert.severity] || "border-slate-200 bg-slate-50 text-slate-700";
                return (
                    <div key={`${alert.type}-${index}`} className={`rounded-lg border px-4 py-3 shadow-sm ${style}`}>
                        <div className="flex items-center justify-between">
                            <div className="text-sm font-semibold uppercase tracking-wide">{alert.type}</div>
                            <div className="text-xs font-medium">{formatTimestamp(alert.detectedAt)}</div>
                        </div>
                        <p className="mt-1 text-sm font-semibold">{alert.target}</p>
                        <p className="mt-1 text-sm">{alert.message}</p>
                    </div>
                );
            })}
        </div>
    );
}
